/* GLS checkout extension. The shared Horizon/Nevios runtime stays untouched. */
(() => {
  'use strict';
  const API = '/a/api/storefront/checkout/gls-point';
  const MAP = 'https://maps.gls-czech.cz/?find=1&ctrcode=CZ';
  const ORIGINS = new Set(['https://maps.gls-czech.cz', 'https://ps-maps.gls-czech.cz', 'https://ps-maps.gls-czech.com']);
  let activeDialog = null;

  function track(name, extra = {}) {
    try { window.analytics?.track(name, { carrier: 'gls', ...extra }); } catch (_) {}
  }
  function storageKey() {
    const checkout = window.neviosCheckout__getCookie?.('neviosCheckout');
    return checkout ? `nv-gls-point:${checkout}:CZ` : null;
  }
  function remember(point) {
    try { const key = storageKey(); if (key) sessionStorage.setItem(key, JSON.stringify(point)); } catch (_) {}
  }
  function remembered() {
    try { const key = storageKey(); const p = key && JSON.parse(sessionStorage.getItem(key)); return p?.country === 'CZ' && p.point_id ? p : null; } catch (_) { return null; }
  }
  function setPoint(widget, point) {
    widget.querySelector('.nch_widget_point_data')?.remove();
    const data = document.createElement('div');
    data.className = 'nch_widget_point_data';
    data.hidden = true;
    const fields = { 'id': point.point_id, 'name': point.point_name, 'address': point.address, 'city': point.city, 'zip': point.zip };
    for (const [key, value] of Object.entries(fields)) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.setAttribute(`data-point-${key}`, ''); input.value = value;
      data.appendChild(input);
    }
    widget.appendChild(data);
    const status = widget.querySelector('.nch_widget_status');
    status.classList.replace('nch_widget_status--empty', 'nch_widget_status--selected');
    widget.querySelector('.nch_widget_placeholder').style.display = 'none';
    const name = widget.querySelector('.nch_widget_point_name');
    name.textContent = point.point_name; name.style.display = '';
    const address = widget.querySelector('.nch_widget_point_detail');
    address.textContent = `${point.address}, ${point.zip} ${point.city}`; address.style.display = '';
    widget.querySelector('.nch_widget_icon_alert').style.display = 'none';
    widget.querySelector('.nch_widget_icon_ok').style.display = '';
    widget.querySelector('.nch_widget_btn_text').textContent = 'Změnit pobočku';
    widget.querySelector('[data-gls-error]').textContent = '';
    widget.classList.add('nv-gls--selected');
  }
  async function resolve(id) {
    const response = await fetch(`${API}?${new URLSearchParams({ id, country: 'CZ' })}`, { signal: AbortSignal.timeout(12000) });
    const result = await response.json();
    if (!response.ok || !result.success) throw new Error(result.error || 'Výdejní místo se nepodařilo ověřit. Zkuste to znovu.');
    return result.data;
  }
  function openPicker(button) {
    if (activeDialog) return;
    const widget = button.closest('[data-gls-widget]');
    const radio = button.closest('.nch_shipping_option')?.querySelector('input[name="shipping"]');
    if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
    if (window.selectedCountry && window.selectedCountry !== 'CZ') {
      widget.querySelector('[data-gls-error]').textContent = 'GLS je dostupné pouze pro doručení v Česku.';
      return;
    }
    const dialog = document.createElement('dialog');
    dialog.className = 'nv-gls-dialog';
    dialog.setAttribute('aria-labelledby', 'nv-gls-title');
    dialog.innerHTML = '<div class="nv-gls-dialog__header"><span id="nv-gls-title">Vyberte výdejní místo nebo box</span><button type="button" class="nv-gls-dialog__close" aria-label="Zavřít výběr výdejního místa">×</button></div><p class="nv-gls-dialog__message" role="status">Načítám mapu GLS…</p><iframe title="Mapa výdejních míst a boxů GLS" class="nv-gls-dialog__map"></iframe>';
    document.body.appendChild(dialog);
    activeDialog = dialog;
    const frame = dialog.querySelector('iframe');
    const message = dialog.querySelector('[role="status"]');
    const previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    let closed = false;
    let pending = false;
    const timeout = setTimeout(() => { if (!closed) message.textContent = 'Mapa se načítá déle. Výběr můžete zavřít a zkusit znovu.'; }, 12000);
    const close = () => {
      if (closed) return;
      closed = true; clearTimeout(timeout);
      window.removeEventListener('message', receiver);
      dialog.close(); dialog.remove(); activeDialog = null;
      document.documentElement.style.overflow = previousOverflow;
      button.focus();
    };
    const receiver = async event => {
      if (closed || pending || event.source !== frame.contentWindow || !ORIGINS.has(event.origin)) return;
      const row = event.data?.parcelshop?.detail || event.data?.parcelshop;
      if (!row || typeof row.pclshopid !== 'string') return;
      if (row.ctrcode && row.ctrcode !== 'CZ') { message.textContent = 'Vyberte prosím výdejní místo v Česku.'; return; }
      pending = true;
      message.textContent = 'Ověřuji dostupnost výdejního místa…';
      try {
        const point = await resolve(row.pclshopid);
        if (closed) return;
        // A country/shipping refresh can replace the original widget while the map is open.
        const current = widget.isConnected ? widget : document.querySelector('[data-gls-widget]');
        if (!current || (window.selectedCountry && window.selectedCountry !== 'CZ')) { close(); return; }
        setPoint(current, point); remember(point);
        track('gls_point_selected', { point_type: point.point_type });
        close();
      } catch (error) {
        if (!closed) { message.textContent = error.message; track('gls_point_error'); }
      } finally { pending = false; }
    };
    window.addEventListener('message', receiver);
    dialog.querySelector('button').addEventListener('click', close);
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
    frame.addEventListener('load', () => { clearTimeout(timeout); if (!pending) message.textContent = ''; });
    frame.src = MAP;
    dialog.showModal();
    track('gls_map_opened');
  }
  function mount() {
    document.querySelectorAll('[data-gls-widget]:not([data-gls-ready])').forEach(widget => {
      widget.setAttribute('data-gls-ready', '');
      widget.querySelector('[data-gls-pick]').addEventListener('click', event => { event.preventDefault(); openPicker(event.currentTarget); });
      const point = remembered();
      if (point) setPoint(widget, point);
    });
  }
  function install() {
    if (!window.neviosCheckout__widgets) return;
    window.neviosCheckout__widgets.gls = () => {
      // Use exactly the shared carrier structure and theme settings (fonts, colors, spacing).
      const template = document.createElement('template');
      template.innerHTML = window.neviosCheckout__renderWidgetHTML('gls');
      const widget = template.content.firstElementChild;
      widget.classList.add('nv-gls');
      widget.setAttribute('data-gls-widget', '');
      const button = widget.querySelector('.nch_widget_btn');
      button.removeAttribute('onclick');
      button.setAttribute('data-gls-pick', '');
      const error = document.createElement('p');
      error.setAttribute('data-gls-error', ''); error.setAttribute('role', 'alert');
      widget.appendChild(error);
      return widget.outerHTML;
    };
    // Existing renderer inserts carrier HTML asynchronously and after country/price changes.
    const container = document.querySelector('.nch_shipping_container');
    if (container) new MutationObserver(mount).observe(container, { childList: true, subtree: true });
    mount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();
})();
